import { Component, OnInit, inject } from '@angular/core';
import { ExternalLoginService } from '../../services';

@Component({
  selector: 'app-external-login',
  templateUrl: 'external-login.component.html',
})
export class ExternalLoginComponent implements OnInit {
  private readonly externalAuthService = inject(ExternalLoginService);

  ngOnInit() {
    // sessionStorage.clear();
    this.externalAuthService.loginExternalUser();
  }
}
